var image_loading = require( './image-loading' );

var scroll_load = ( function ( $ ) {

	// Pages to load in advance, before the user scrolls to them
	var PAGES_AHEAD = 2;
	// Number of pages that have already been loaded by the initial request
	var PAGES_PRE_LOADED = parseInt(ScriptData.page_to);
	// Container of pages
	var PAGES_CONTAINER = '.infinite-grid';

	var pages_loaded = PAGES_PRE_LOADED;
	var pages_loading = false;
	var enabled = true;
	var $pages_container = null;
	var scroll_points = [];
	var $spinner = null;

	var _add_to_queue = function( value ) {
		scroll_points.push( value );
	};

	var _pop_queue = function() {
		scroll_points.shift();
	};

	var _process_new_page = function( $page ) {
		_insert_page( $page );
		pages_loaded++;
		pages_loading = false;
		_update_state();

		if ( scroll_points.length > PAGES_AHEAD ) {
			_pop_queue();
		}

		_add_to_queue( $pages_container.height() );
	};

	var _init = function() {
		$pages_container = $( PAGES_CONTAINER );
		$spinner         = $pages_container.next( '.ajax-spinner' );
		_add_to_queue( $pages_container.height() );
		_check_next_page();
	};

	var _get_next_page = function() {
		var url             = new URL( window.location.href );
		var current_version = url.href.includes('en-us') ? 'us' : 'european';

		var data = {
			action: 'get_posts',
			scroll_load_nonce: ScriptData.scroll_load_nonce,
			query_vars: infinite_vars.query,
			args: infinite_vars.args,
			page: pages_loaded + 1,
			site_version: current_version,
		};

		loading();
		$.get( ScriptData.ajaxurl, data, _received_page ).fail( _handle_post_error );
		pages_loading = true;
	};

	var _handle_post_error = function( response ) {
		_enable_paging();
	};

	var _enable_paging = function() {
		$( '.pagination' ).show();
		enabled = false;

		$( document ).off( 'scroll', _check_next_page );

		loaded();
	};

	var _received_page = function( response ) {
		if ( response.html ) {
			var $page = $( $.parseHTML( response.html ) );
			_process_new_page( $page );
			$( document ).trigger( 'pageloaded', [$page] );

			_check_next_page();
		} else if ( response.success ) {
			// No html but was a successful request so stop checking
			enabled = false;
			loaded();
		} else {
			// Treat as an error
			_handle_post_error( response )
		}
	};

	var _insert_page = function( $html ) {
		$html.imagesLoaded( function() {
			$html.hide();
			image_loading.add_listeners_for( $html );
			$pages_container.append( $html );
			$html.fadeIn( 600 );
		});

		loaded();
	};

	var _check_next_page = function() {
		if ( enabled && ! pages_loading ) {
			var get_next_page = false;

			var distance_from_bottom = scroll_points[0] - window.scrollY + $pages_container.offset().top - $( window ).height();
			if ( distance_from_bottom < 0 ) {
				get_next_page = true;
			}

			if ( scroll_points.length <= PAGES_AHEAD ) {
				get_next_page = true;
			}

			if ( get_next_page ) {
				_get_next_page();
			}
		}
	};

	var loading = function() {
		$spinner.addClass( 'active' );
	};

	var loaded = function() {
		$spinner.removeClass( 'active' );
	};

	var _update_state = function() {
		if ( ! window.history || ! history.replaceState ) {
			return false;
		}

		var uri = URI( window.location.search );

		if ( ! uri.hasQuery( 'page_from' ) ) {
			uri.addQuery( 'page_from', 1 );
		}

		if ( uri.hasQuery( 'page_to' ) ) {
			uri.removeQuery( 'page_to' );
		}
		uri.addQuery( 'page_to', pages_loaded );

		var new_state = window.location.href.replace( window.location.search, '' );
		new_state += uri.toString();

		window.history.replaceState( null, '', new_state );

		_update_pagination_links();

		return true;
	};

	var _update_pagination_links = function () {
		var url             = new URL( window.location.href );
		var current_version = url.href.includes('en-us') ? 'us' : 'european';

		var data = {
			action: 'get_post_pagination_links',
			pagination_nonce: ScriptData.pagination_nonce,
			current_page: pages_loaded,
			query_vars: infinite_vars.query,
			base_url: window.location.origin + window.location.pathname,
			site_version: current_version,
		};

		$.get( ScriptData.ajaxurl, data, _received_pagination_links );
	};

	var _received_pagination_links = function( response ) {
		if ( response.html || response.more ) {
			$( '.pagination' ).replaceWith( response.html );
		}
	};

	if ( $( '.infinite-grid' ).length > 0 ) {
		$( document ).on( 'ready', _init );

		document.addEventListener( 'scroll', _check_next_page, {passive: true} );
	}

	return {};

} ) ( jQuery );

module.exports = scroll_load;